<template>
  <div class="page page-inner">
    <breadcrumb title="Approval Time Recording"></breadcrumb>
    <div class="card card-fluid">
      <!-- .card-body -->
      <div class="card-body">
        <div class="tab-content py-3" >
          <div class="tab-pane fade active show" >
            <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
              <div class="row">
                <div class="col-sm-12 col-md-6">

                </div>
              </div>

              <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover class="table-height" :class="{'hide-scroll': isScrollHide()}">

              </b-table>
              <div class="row">
                <div class="form-actions">
                  <button class="btn btn-success float-left mr-1" @click="stat_id=3;handleOk($event)"> Approve </button>
                  <button class="btn btn-danger float-left mr-1" @click="stat_id=2; handleOk($event)"> Hold </button>
                </div>
              </div>
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_info" id="data-table-leave-request-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
                </div>
                <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                  <div class="dataTables_paginate paging_simple_numbers">
                    <b-pagination v-model="currentPage" v-on:input="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {mapGetters} from "vuex";
import {BTable, BPagination} from "bootstrap-vue"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
export default {
  name: "TimeRecordingApproval",
  components:{
    Breadcrumb,
    BTable,
    BPagination,
  },
  props:{
    emp_id:{
      type:String
    },
    period:{
      type:String
    }
  },
  data(){
    return {
      detail:{},
      stat_id:3,
      remarkState:false,
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      rows:0,
      perPage:31,
      currentPage:1,
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'project_name',label:'Project', sortable: true },
        { key: 'date', sortable: true },
        { key: 'time',label:'Hours', sortable: true },
        { key: 'category_name',label:'Category', sortable: true },
        { key: 'remarks', sortable: true ,thStyle: {width:'400px'}},
      ],
      data:{
        hours:"",
        project:"",
        remarks:"",
        date:""
      },
      option_hours:[],
      option_project:[]
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },

  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    getData(){
      this.items = []
      let firstDay = (this.$route.query.id !== undefined) ? this.detail.period : atob(this.period)

      let emp_id = this.emp_id !== undefined ? atob(this.emp_id) : this.detail.emp_id
      let date = new Date(this.formatDate(firstDay))
      let lastDay = this.formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
      let payload = {emp_id: emp_id, start_date: firstDay, end_date: lastDay, lang: "en"}
      AxiosCall.Get(payload, urlApi.time_recording.get_data).then(res => {
        if (res.success){
          this.perPage = res.total
          this.rows = res.total
          let no = (this.currentPage - 1) * this.perPage + 1
          for (let data of res.atributes){
            if (data.weekend === 1){
              data._rowVariant = 'info';
              if (data.remarks === null ) data.remarks = "Weekend";
            }
            data.no = no++
            data.date = data.date.replace("T", " ").replace("Z", "")
            this.items.push(data)
          }

        }else{
          this.errorMessage(res.message)
        }

      }).catch(e=>{
        console.log(e)
      })
    },
    getDetail(){

      let payload = {}
      if (this.$route.query.id !== undefined){ payload = {id: atob(this.$route.query.id)}}else {
        payload = {
          period : atob(this.period),
          emp_id : atob(this.emp_id)
        }
      }

      AxiosCall.Get(payload, urlApi.time_recording.detail).then(res=>{
        if(res.success){
          this.detail = res.atributes[0]
          this.getData()
        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    formatDate(date) {
      let tgl = date.toLocaleString().split(" ")
      let d = new Date(tgl[0]),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    handleOk(){
      let payload = {
        stat_id:this.stat_id,
        master_id:this.detail.master_id,
        log_id:this.detail.log_id
      }

      AxiosCall.Post(payload, urlApi.time_recording.approval).then(res=>{
        if(res.success){
          this.successMessage(res.message)
          this.$router.push({name:"ListTimeRecording"})
        }else {
          this.errorMessage(res.message)
        }
      }).catch(e=>{
        this.errorMessage(e.response.data.message)
      })
    }
  },
  created() {
    if(!this.$store.getters.isMultiple){
      this.fields = this.fields.filter((field)=>{
        return field.key !== 'project_name'
      })
    }
    this.getDetail()
  }
}
</script>